module.exports = __webpack_public_path__ + "static/blog-d56a8b293b83957d20faca40408f0e7e.svg";